import { selectTenant } from 'state/tenant';
import useLoadInitialPrequalOfferData from './useLoadInitialPrequalOfferData';
import useLoadInitialCreditApplicationData from 'hooks/useLoadInitialCreditApplicationData';
import { useSelector } from 'react-redux';

const useLoadInitialData = () => {
  let initialCreditApplicationKeys: string[] = [
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'emailAddress',
    'mobilePhone',
    'alternativePhone',
    'storeNumber',
    'category',
    'cardType',
    'cartAmount',
    'checkoutAmount',
    'correlationData',
    'customerNumber',
    'loyaltyNumber',
    'productAmount',
    'sku',
    'clientVariable1',
    'clientVariable2',
    'clientVariable3',
    'clientVariable4',
    'associateId',
    'selectedCardKey',
    'overrideKey',
    'cardChoiceCode',
  ];

  let initialPrequalOfferKeys: string[] = [];

  const addToCreditAppKeys = (keysToAdd: string[]): void => {
    initialCreditApplicationKeys = initialCreditApplicationKeys.concat(
      keysToAdd,
    );
  };

  const addToPrequalOfferKeys = (keysToAdd: string[]): void => {
    initialPrequalOfferKeys = initialPrequalOfferKeys.concat(keysToAdd);
  };

  const { overrideConfig } = useSelector(selectTenant);
  if (overrideConfig.unifiedPrequalCheckout) {
    addToCreditAppKeys(['order', 'shippingAddress']);
    addToPrequalOfferKeys(['prequalCreditLimit']);
  }

  useLoadInitialPrequalOfferData(initialPrequalOfferKeys);
  return useLoadInitialCreditApplicationData(initialCreditApplicationKeys);
};

export default useLoadInitialData;
